<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
      :margin="$attrs.margin"
    >
      <div class="select-wrapper">
        <select
          :id="id"
          v-model="model"
          :class="{'is-invalid': !valid && validated}"
          :name="name"
          v-bind="$attrs"
          class="form-control"
          v-on="listeners"
        >
          <option
            v-if="$attrs.placeholder"
            :value="undefined"
            disabled
            hidden
          >
            {{ $attrs.placeholder }}
          </option>
          <slot>
            <template
              v-for="option of options"
            >
              <option
                v-if="option.visible == undefined || option.visible === true"
                :key="option.id || option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </template>
          </slot>
        </select>
      </div>
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicSelect',
  mixins: [basicComponentMixin],
  props: {
    options: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>
